<div class="select-fields-dialog">
  <div class="select-fields-header">
    <h2 class="select-fields-title">Оберіть поля для секції</h2>
    <div class="select-fields-header-actions">
      @if (data.funnelId) {
        <button class="select-fields-create" type="button" (click)="openCustomFieldForm()">
          <app-icon class="icon-sm">add</app-icon>
          {{ 'create_field' | translate }}
        </button>
      }
      <button class="select-fields-close" (click)="onCancel()">
        <app-icon class="icon-sm">close</app-icon>
      </button>
    </div>
  </div>

  <div class="select-fields-content">
    @if (creatingCustomField) {
      <div class="select-fields-create-form">
        <div class="select-fields-create-form-title">{{ 'create_field' | translate }}</div>
        <input
          class="select-fields-input"
          [formControl]="customFieldName"
          [placeholder]="'name_field' | translate"
        />
        <input
          class="select-fields-input"
          [formControl]="customFieldKey"
          [placeholder]="'key_field' | translate"
        />
        <select class="select-fields-input" [formControl]="customFieldType">
          <option value="text">Text</option>
          <option value="textarea">Textarea</option>
          <option value="link">Link</option>
          <option value="checkbox">Checkbox</option>
        </select>
        @if (customFieldError) {
          <div class="select-fields-create-error">{{ customFieldError }}</div>
        }
        <div class="select-fields-create-actions">
          <app-button btnType="stroked" (click)="cancelCustomFieldForm()" [disabled]="savingCustomField">
            {{ 'cancel' | translate }}
          </app-button>
          <app-button (click)="createCustomField()" [disabled]="savingCustomField">
            {{ 'add' | translate }}
          </app-button>
        </div>
      </div>
    }
    <div class="select-fields-list">
      @for (field of availableFields; track field.key) {
        <div class="select-fields-item" (click)="toggleField(field)">
          <input
            type="checkbox"
            [checked]="field.selected"
            class="select-fields-checkbox"
            (click)="$event.stopPropagation()"
            (change)="toggleField(field)"
          />
          @if (field.translate) {
            <span class="select-fields-label">{{ field.title | translate }}</span>
          } @else {
            <span class="select-fields-label">{{ field.title }}</span>
          }
          <span class="select-fields-type">({{ field.type }})</span>
        </div>
      }
    </div>
  </div>

  <div class="select-fields-footer">
    <app-button btnType="stroked" (click)="onCancel()">Скасувати</app-button>
    <app-button (click)="onConfirm()">Додати обрані</app-button>
  </div>
</div>
